<template>
  <div style="padding: 0 15px; overflow-x: hidden;">
    <a-row :gutter="[24, 24]">
      <a-col :xs="24" :md="14" :lg="14">
        <div class="car-list-container">
          <a-list :data-source="dataCar" :render-item="renderCarItem" item-layout="horizontal" />
        </div>
      </a-col>
      <a-col :xs="24" :md="10" :lg="10">
        <h5 class="mt-5 mb-5">Record your car information</h5>
        <a-form-model ref="carForm" :model="formCar" :rules="rules" layout="vertical">

          <!-- BRAND -->
          

          <a-form-model-item label="BRAND" prop="brand">
            <a-auto-complete
              v-model="formCar.brand"
              :data-source="brandOptions"
              placeholder="Select or type car brand"
              :filter-option="filterBrand"
              allow-clear
            />
          </a-form-model-item>

          <!-- MODEL / COLOR -->
          <a-row :gutter="8">
            <a-col :span="12">
              <a-form-model-item label="MODEL" prop="model">
                <a-input v-model="formCar.model" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="COLOR" prop="color">
                <a-input v-model="formCar.color" />
              </a-form-model-item>
            </a-col>
          </a-row>

          <!-- LICENSE PLATE -->
          <a-form-model-item label="VEHICLE LICENSE PLATE">
            <a-row :gutter="8">
              <a-col :span="8">
                <a-form-model-item prop="license_plate_prefix">
                  <a-input v-model="formCar.license_plate_prefix" placeholder="Prefix" />
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item prop="license_plate_number">
                  <a-input v-model="formCar.license_plate_number" placeholder="Number" />
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item prop="province">
                  <a-select v-model="formCar.province">
                    <a-select-option v-for="p in provinces" :key="p.value" :value="p.value">
                      {{ p.text }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model-item>

          <!-- FUEL -->
          <a-form-model-item label="TYPE OF FUEL" prop="fuel_type">
            <a-radio-group v-model="formCar.fuel_type">
              <a-radio v-for="f in fuleoption" :key="f.value" :value="f.value">
                {{ f.text }}
              </a-radio>
            </a-radio-group>
          </a-form-model-item>

          <!-- PHONE -->
          <a-form-model-item label="PHONE NUMBER" prop="contact_number">
            <a-input v-model="formCar.contact_number" />
          </a-form-model-item>

          <!-- REMARK -->
          <a-form-model-item label="NOTE">
            <a-input v-model="formCar.remark" />
          </a-form-model-item>

          <a-alert
            v-if="errorAdd"
            class="font-web mt-5 mb-20"
            message="Unable to Save Vehicle Information"
            description="We were unable to save your vehicle information at this time. Please contact the system administrator or support staff for further assistance."
            type="error"
          />

          <a-button type="primary" block @click="submitForm">
            Register to reserve parking
          </a-button>
        </a-form-model>
      </a-col>
    </a-row>
  </div>
</template>

<script>
const provinces = [
  { value: "กระบี่", text: "กระบี่" },
  { value: "กรุงเทพมหานคร", text: "กรุงเทพมหานคร" },
  { value: "กาญจนบุรี", text: "กาญจนบุรี" },
  { value: "กาฬสินธุ์", text: "กาฬสินธุ์" },
  { value: "กำแพงเพชร", text: "กำแพงเพชร" },
  { value: "ขอนแก่น", text: "ขอนแก่น" },
  { value: "จันทบุรี", text: "จันทบุรี" },
  { value: "ฉะเชิงเทรา", text: "ฉะเชิงเทรา" },
  { value: "ชลบุรี", text: "ชลบุรี" },
  { value: "ชัยนาท", text: "ชัยนาท" },
  { value: "ชัยภูมิ", text: "ชัยภูมิ" },
  { value: "ชุมพร", text: "ชุมพร" },
  { value: "ตรัง", text: "ตรัง" },
  { value: "ตราด", text: "ตราด" },
  { value: "ตาก", text: "ตาก" },
  { value: "นครนายก", text: "นครนายก" },
  { value: "นครปฐม", text: "นครปฐม" },
  { value: "นครพนม", text: "นครพนม" },
  { value: "นครราชสีมา", text: "นครราชสีมา" },
  { value: "นครศรีธรรมราช", text: "นครศรีธรรมราช" },
  { value: "นครสวรรค์", text: "นครสวรรค์" },
  { value: "นนทบุรี", text: "นนทบุรี" },
  { value: "นราธิวาส", text: "นราธิวาส" },
  { value: "น่าน", text: "น่าน" },
  { value: "บุรีรัมย์", text: "บุรีรัมย์" },
  { value: "ปทุมธานี", text: "ปทุมธานี" },
  { value: "ประจวบคีรีขันธ์", text: "ประจวบคีรีขันธ์" },
  { value: "ปราจีนบุรี", text: "ปราจีนบุรี" },
  { value: "ปัตตานี", text: "ปัตตานี" },
  { value: "พะเยา", text: "พะเยา" },
  { value: "พังงา", text: "พังงา" },
  { value: "พัทลุง", text: "พัทลุง" },
  { value: "พิจิตร", text: "พิจิตร" },
  { value: "พิษณุโลก", text: "พิษณุโลก" },
  { value: "เพชรบุรี", text: "เพชรบุรี" },
  { value: "เพชรบูรณ์", text: "เพชรบูรณ์" },
  { value: "แพร่", text: "แพร่" },
  { value: "ภูเก็ต", text: "ภูเก็ต" },
  { value: "มหาสารคาม", text: "มหาสารคาม" },
  { value: "มุกดาหาร", text: "มุกดาหาร" },
  { value: "แม่ฮ่องสอน", text: "แม่ฮ่องสอน" },
  { value: "ยโสธร", text: "ยโสธร" },
  { value: "ยะลา", text: "ยะลา" },
  { value: "ร้อยเอ็ด", text: "ร้อยเอ็ด" },
  { value: "ระนอง", text: "ระนอง" },
  { value: "ระยอง", text: "ระยอง" },
  { value: "ราชบุรี", text: "ราชบุรี" },
  { value: "ลพบุรี", text: "ลพบุรี" },
  { value: "ลำปาง", text: "ลำปาง" },
  { value: "ลำพูน", text: "ลำพูน" },
  { value: "เลย", text: "เลย" },
  { value: "ศรีสะเกษ", text: "ศรีสะเกษ" },
  { value: "สกลนคร", text: "สกลนคร" },
  { value: "สงขลา", text: "สงขลา" },
  { value: "สตูล", text: "สตูล" },
  { value: "สมุทรปราการ", text: "สมุทรปราการ" },
  { value: "สมุทรสงคราม", text: "สมุทรสงคราม" },
  { value: "สมุทรสาคร", text: "สมุทรสาคร" },
  { value: "สระแก้ว", text: "สระแก้ว" },
  { value: "สระบุรี", text: "สระบุรี" },
  { value: "สิงห์บุรี", text: "สิงห์บุรี" },
  { value: "สุโขทัย", text: "สุโขทัย" },
  { value: "สุพรรณบุรี", text: "สุพรรณบุรี" },
  { value: "สุราษฎร์ธานี", text: "สุราษฎร์ธานี" },
  { value: "สุรินทร์", text: "สุรินทร์" },
  { value: "หนองคาย", text: "หนองคาย" },
  { value: "หนองบัวลำภู", text: "หนองบัวลำภู" },
  { value: "อ่างทอง", text: "อ่างทอง" },
  { value: "อุดรธานี", text: "อุดรธานี" },
  { value: "อุตรดิตถ์", text: "อุตรดิตถ์" },
  { value: "อุทัยธานี", text: "อุทัยธานี" },
  { value: "อุบลราชธานี", text: "อุบลราชธานี" },
  { value: "อำนาจเจริญ", text: "อำนาจเจริญ" }
];

const carBrands = [
  { value: "Acura", text: "Acura" },
  { value: "Aiways", text: "Aiways" },
  { value: "Alfa Romeo", text: "Alfa Romeo" },
  { value: "Aston Martin", text: "Aston Martin" },
  { value: "Audi", text: "Audi" },
  { value: "Bentley", text: "Bentley" },
  { value: "BMW", text: "BMW" },
  { value: "BYD", text: "BYD" },
  { value: "Bugatti", text: "Bugatti" },
  { value: "Cadillac", text: "Cadillac" },
  { value: "Changan", text: "Changan" },
  { value: "Chevrolet", text: "Chevrolet" },
  { value: "Chrysler", text: "Chrysler" },
  { value: "Dodge", text: "Dodge" },
  { value: "Ferrari", text: "Ferrari" },
  { value: "Fiat", text: "Fiat" },
  { value: "Ford", text: "Ford" },
  { value: "Genesis", text: "Genesis" },
  { value: "GMC", text: "GMC" },
  { value: "GWM", text: "GWM" },
  { value: "Honda", text: "Honda" },
  { value: "Hyundai", text: "Hyundai" },
  { value: "Infiniti", text: "Infiniti" },
  { value: "Isuzu", text: "Isuzu" },
  { value: "Jaguar", text: "Jaguar" },
  { value: "Jeep", text: "Jeep" },
  { value: "Kia", text: "Kia" },
  { value: "Lamborghini", text: "Lamborghini" },
  { value: "Land Rover", text: "Land Rover" },
  { value: "Lexus", text: "Lexus" },
  { value: "Mazda", text: "Mazda" },
  { value: "McLaren", text: "McLaren" },
  { value: "Mercedes-Benz", text: "Mercedes-Benz" },
  { value: "Mini", text: "Mini" },
  { value: "Mitsubishi", text: "Mitsubishi" },
  { value: "Nissan", text: "Nissan" },
  { value: "Ora", text: "Ora" },
  { value: "Pagani", text: "Pagani" },
  { value: "Peugeot", text: "Peugeot" },
  { value: "Porsche", text: "Porsche" },
  { value: "Ram", text: "Ram" },
  { value: "Renault", text: "Renault" },
  { value: "Rolls-Royce", text: "Rolls-Royce" },
  { value: "Saab", text: "Saab" },
  { value: "Skoda", text: "Skoda" },
  { value: "Subaru", text: "Subaru" },
  { value: "Suzuki", text: "Suzuki" },
  { value: "Tesla", text: "Tesla" },
  { value: "Toyota", text: "Toyota" },
  { value: "Volkswagen", text: "Volkswagen" },
  { value: "Volvo", text: "Volvo" },
  { value: "Xpeng", text: "Xpeng" }
];

export default {
  props: {
    formCar: {
      type: Object,
      default: () => { },
    },
    dataCar: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      formLayout: 'vertical',
      errorAdd: false,
      carBrands,
      provinces,
      fuleoption: [
        { value: "Oil", text: "Gasoline" },
        { value: "EV (Electric Vehicle)", text: "EV (Electric Vehicle)" },
        { value: "HYBRID (HEV)", text: "HYBRID (HEV)" },
        { value: "PLUG-IN ELECTRIC (PHEV OR BEV)", text: "PLUG-IN ELECTRIC (PHEV OR BEV)" },
        // { value: "Gas", text: "LPG/NGV" },
      ],
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
      },
      // 
      rules: {
        brand: [{ required: true, message: "กรุณาเลือกยี่ห้อรถ" }],
        model: [{ required: true, message: "กรุณากรอกรุ่นรถ" }],
        color: [{ required: true, message: "กรุณากรอกสีรถ" }],
        license_plate_prefix: [
          { required: true, message: "กรุณากรอกอักษรนำหน้าทะเบียน" },
          { validator: this.validatePlatePrefix }
        ],
        license_plate_number: [
          { required: true, message: "กรุณากรอกเลขทะเบียน" },
          { validator: this.validatePlateNumber }
        ],
        province: [{ required: true, message: "กรุณาเลือกจังหวัด" }],
        fuel_type: [{ required: true, message: "กรุณาเลือกประเภทน้ำมัน" }],
        contact_number: [
          { required: true, message: "กรุณากรอกเบอร์โทรศัพท์" },
          { validator: this.validatePhone }
        ]
      }
    };
  },
  mounted() { },
  computed: {
    brandOptions() {
      return this.carBrands.map(b => b.text);
    }
  },
  methods: {
    filterBrand(inputValue, option) {
      return option
        .toUpperCase()
        .includes(inputValue.toUpperCase());
    },
    renderCarItem(item) {
      return (
        <a-list-item class="car-item">
          <a-card hoverable style="width: 100%;">
            <div class="car-info font-web">
              <div class="info-row">
                <span class="info-title"><a-icon type="car" /> Model</span>
                <span style="font-size: 20px;font-weight: 700;" class="info-value">{item.model}</span>
              </div>
              <div class="info-row">
                <span class="info-title"><a-icon type="bars" /> License Plate</span>
                <span style="font-size: 20px;font-weight: 700;" class="info-value">
                  {item.license_plate_prefix} {item.license_plate_number}
                </span>
              </div>

              <div class="info-row">
                <span class="info-title"><a-icon type="bars" /> Fuel Type</span>
                <span style="font-size: 20px;font-weight: 700;" class="info-value">{item.fuel_type}</span>
              </div>

              <div class="info-row">
                <span class="info-title"><a-icon type="wallet" /> Parking Fee Status</span>
                <span style="font-size: 20px;font-weight: 700;" class="info-value">{item.parking_status}</span>
              </div>
            </div>
          </a-card>
        </a-list-item>
      );
    },
    // form controll

    validatePlatePrefix(rule, value, callback) {
        const regex = /^(?:[ก-ฮ]{1,2}|\d[ก-ฮ]{2})$/;
        if (!value) {
          callback("กรุณากรอกอักษรนำหน้าทะเบียน");
        } else if (!regex.test(value)) {
          callback("รูปแบบไม่ถูกต้อง เช่น ก, กค, พพ, 4กด, 5พพ");
        } else {
          callback();
        }
    },
    validatePhone(rule, value, callback) {
      const phoneRegex = /^0[0-9]{9}$/;
      if (!value || phoneRegex.test(value)) {
        callback();
      } else {
        callback("เบอร์โทรต้องเป็นตัวเลข 10 หลัก และขึ้นต้นด้วย 0");
      }
    },
    validatePlateNumber(rule, value, callback) {
      if (/^\d{1,4}$/.test(value)) {
        callback();
      } else {
        callback("เลขทะเบียนต้องเป็นตัวเลข 1–4 หลัก");
      }
    },
    async submitForm() {
      this.errorAdd = false
      this.$refs.carForm.validate(async (valid) => {
        if (valid) {
          const sendAddCar = new FormData();
          sendAddCar.append("owner", Number.parseInt(this.$store.state.role.RulesUser.username.replace('u', '')));
          sendAddCar.append("brand", this.formCar.brand);
          sendAddCar.append("model", this.formCar.model);
          sendAddCar.append("color", this.formCar.color);
          sendAddCar.append("license_plate_prefix", this.formCar.license_plate_prefix);
          sendAddCar.append("license_plate_number", this.formCar.license_plate_number);
          sendAddCar.append("province", this.formCar.province);
          sendAddCar.append("fuel_type", this.formCar.fuel_type);
          sendAddCar.append("contact_number", this.formCar.contact_number);
          sendAddCar.append("remark", this.formCar.remark || "");

          try {
            const response = await this.$http.post(
              "/parking/cars/",
              sendAddCar,
              {
                headers: { "Content-Type": "multipart/form-data" },
              }
            );
            if ([200, 201].includes(response.status)) {
              this.$emit('addDataCar', response.data)
            }
            else {
              const error = new Error('Request Failed');
              error.response = response;
              throw error;
            }
          } catch (error) {
            this.errorAdd = true
            console.log(error)
          }
        }
      });
    }
    // 
  },
};
</script>

<style scoped>
.car-row {
  display: flex;
  align-items: flex-start;
}

.car-img {
  width: 140px;
  height: 95px;
  object-fit: cover;
  border-radius: 6px;
  margin-right: 15px;
}

.car-info {
  flex: 1;
}

.car-title {
  margin: 0;
  font-weight: bold;
}

.car-price {
  margin: 4px 0;
  font-weight: 500;
}

.car-year {
  color: #888;
}

.info-row {
  display: flex;
  justify-content: space-between;
  /* ซ้าย-ขวา */
  align-items: center;
  padding: 2px 0;
}

.info-title {
  font-weight: 600;
  color: #a7a7a7 !important;
}

.info-value {
  font-weight: 500;
  color: #000 !important;
  text-align: right;
}
</style>